import { Link } from 'react-router';
import type { LinkComponentProps } from '@wrenpages/design-system';

/** Lets every design-system link navigate client-side through React Router. */
export function RouterLinkAdapter({ href, ...rest }: LinkComponentProps) {
  return <Link to={href} {...rest} />;
}
